<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '../api/auth'
import { useUserStore } from '../stores/user'

const router = useRouter()
const store = useUserStore()

// Reactive form values
const email = ref('')
const password = ref('')
const errorMessage = ref('')
const loading = ref(false)

async function handleLogin() {
  errorMessage.value = ''
  loading.value = true
  try {
    const result = await login(email.value, password.value)
    if (result.success) {
      store.fetchCurrentUser()
      router.push('/clinics')
    } else {
      errorMessage.value = result.error || 'Invalid email or password'
      console.error(result.error)
    }
  } catch (error) {
    errorMessage.value = 'Unable to sign in. Please check your connection and try again.'
    console.error(error)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="w-100 h-100 d-flex flex-column justify-center">  
    <v-card width="780px" class="mx-auto rounded-xl d-flex px-3 pt-6">
      <v-row>

        <v-col cols="5" class="d-flex flex-column pt-4 pl-4">
          
          <v-card-title class="text-dark">
            <h1>Sign in </h1>
          </v-card-title>
          
          <img
          :width="120"
          :max-height="60"
          class="ml-4"
          cover
          src="/res.png"
          />

          <v-card-text>
            Enter your email and password to sign in.
          </v-card-text>

        
        </v-col>
        
        <v-divider vertical />
        
        <v-col cols="7" class="pt-12 pr-4">
          <v-form class="pa-4" >
            <v-text-field
            v-model="email"
            label="Email"
            prepend-inner-icon="mdi-account-circle"
            color="#112e34"
            />
            <v-text-field
            v-model="password"
            type="password"
            label="Password"
            prepend-inner-icon="mdi-lock"
            color="#112e34"
            @keyup.enter="handleLogin"
            />
          </v-form>

          <v-alert
            v-if="errorMessage"
            type="error"
            variant="tonal"
            class="mx-4"
          >
            {{ errorMessage }}
          </v-alert>

          <v-card-actions class="ma-2">
            <v-spacer></v-spacer>

            <v-btn class="bg-secondary" variant="elevated" :loading="loading" @click="handleLogin">
              Login
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped>
.card {
  background-color: #fcfffc;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 12px 0 rgba(0, 0, 0, 0.19);
}
</style>
